var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProblemIdentification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 157,
    height: 156,
    viewBox: "0 0 157 156",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.3477 2.08789C81.5693 -0.0493546 89.1619 3.81992 91.3623 10.5742V10.5732C92.299 13.7027 95.2354 15.8169 98.54 15.8828L98.5557 15.8838H108.543C113.61 15.884 117.596 19.783 117.596 24.4395C117.596 29.0959 113.61 32.9949 108.543 32.9951H48.2412C43.174 32.9951 39.1885 29.096 39.1885 24.4395C39.1885 19.7826 43.1706 15.8838 48.2412 15.8838H58.2285L58.2432 15.8828C61.5472 15.817 64.4836 13.7037 65.4209 10.5752C66.7342 6.54858 70.0569 3.35882 74.3477 2.08789Z",
    fill: "#213D68",
    stroke: "#1E1E1E",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.04492 70.6157H51.2559C55.4181 70.6157 58.659 73.8144 58.6592 77.5923C58.6592 81.3703 55.4182 84.5698 51.2559 84.5698H9.04492C4.88275 84.5697 1.64258 81.3702 1.64258 77.5923C1.64273 73.814 4.87953 70.6159 9.04492 70.6157Z",
    fill: "#F13700",
    stroke: "#1E1E1E",
    strokeWidth: 3.28421
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M105.527 70.6157H147.738C151.9 70.6157 155.141 73.8144 155.142 77.5923C155.142 81.3703 151.901 84.5698 147.738 84.5698H105.527C101.365 84.5697 98.125 81.3702 98.125 77.5923C98.1252 73.814 101.362 70.6159 105.527 70.6157Z",
    fill: "#559B2D",
    stroke: "#1E1E1E",
    strokeWidth: 3.28421
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1669 54.6074H123.619V68.9731H129.649V51.7343C129.649 50.1469 128.3 48.8612 126.634 48.8612H81.4079V34.4955H75.3778V48.8612H30.1518C28.486 48.8612 27.1367 50.1469 27.1367 51.7343V68.9731H33.1669V54.6074ZM27.1367 86.2119H33.1669V139.691H27.1367V86.2119ZM123.619 86.2119H129.649V139.691H123.619V86.2119Z",
    fill: "#1E1E1E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.04492 105.093H51.2559C55.4181 105.093 58.659 108.292 58.6592 112.07C58.6592 115.848 55.4182 119.047 51.2559 119.047H9.04492C4.88275 119.047 1.64258 115.848 1.64258 112.07C1.64273 108.292 4.87953 105.093 9.04492 105.093Z",
    fill: "#F13700",
    stroke: "#1E1E1E",
    strokeWidth: 3.28421
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.04492 140.404H51.2559C55.4181 140.404 58.659 143.602 58.6592 147.38C58.6592 151.158 55.4182 154.358 51.2559 154.358H9.04492C4.88275 154.358 1.64258 151.158 1.64258 147.38C1.64273 143.602 4.87953 140.404 9.04492 140.404Z",
    fill: "#F13700",
    stroke: "#1E1E1E",
    strokeWidth: 3.28421
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M105.527 105.093H147.738C151.9 105.093 155.141 108.292 155.142 112.07C155.142 115.848 151.901 119.047 147.738 119.047H105.527C101.365 119.047 98.125 115.848 98.125 112.07C98.1252 108.292 101.362 105.093 105.527 105.093Z",
    fill: "#559B2D",
    stroke: "#1E1E1E",
    strokeWidth: 3.28421
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M105.527 140.404H147.738C151.9 140.404 155.141 143.602 155.142 147.38C155.142 151.158 151.901 154.358 147.738 154.358H105.527C101.365 154.358 98.125 151.158 98.125 147.38C98.1252 143.602 101.362 140.404 105.527 140.404Z",
    fill: "#559B2D",
    stroke: "#1E1E1E",
    strokeWidth: 3.28421
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProblemIdentification);
export default __webpack_public_path__ + "static/media/problem_identification.b0ce7aa6bb9a646df89273130effa1ca.svg";
export { ForwardRef as ReactComponent };